import { Card, makeStyles } from '@material-ui/core';
import {
  CoverageCatalog,
  CoverageCatalogResume,
  Quotation,
  QuotationUnit,
} from 'data-layer-cr/dist/models';
import { ReactNode } from 'react';

export type CardIndividualProps = {
  unit: QuotationUnit;
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
  packageOption: number;
  moneyType: string | undefined;
  quotation: Quotation;
  openDialog?: boolean;
};

type Props = {
  children?: ReactNode;
  isPremiumOption?: boolean;
};

const useStyles = makeStyles(() => ({
  cardRoot: {
    paddingTop: 20,
    paddingBottom: 15,
    paddingLeft: 30,
    paddingRight: 30,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
    background: (isPremium): string =>
      isPremium
        ? 'linear-gradient(0.16deg, #ffffff 13.23%, #cee8ff 105.34%)'
        : '',
  },
}));

export const CardIndividual = ({
  children,
  isPremiumOption,
}: Props): JSX.Element => {
  const classes = useStyles(Boolean(isPremiumOption));
  return (
    <Card className={classes.cardRoot} data-testid="individual-card-layout">
      {children}
    </Card>
  );
};
